export default __webpack_public_path__ + "static/media/declaration-img.285fc23d.png";